<template>
  <sayquick-card title="Academic Years">
    <template v-slot:header-actions>
      <v-btn color="primary" icon class="elevation-3">
        <v-icon @click="showD=!showD">add</v-icon>
      </v-btn>

      <v-spacer></v-spacer>
       <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
            style="max-width:40%"
          ></v-text-field>
    </template>
    <template v-slot:card-content>
      <v-data-table :headers="years_headers" :items="acyears" class="elevation-0" :search="search">
        <template v-slot:items="props">
          <td>{{ props.index + 1 }}</td>

          <td class="text-xs-center">{{ props.item.name }}</td>
          <td class="text-xs-center">{{ props.item.year }}</td>
          <td class="text-xs-center">
            <v-switch :input-value="setSwitchState(props.item)" :loading="sloading" @change="savesetting(props.item)"></v-switch>
          </td>

          <td class="text-xs-center">
            <v-layout row wrap>
              <v-flex xs6>
                <v-btn flat icon color="blue" @click="editacyear(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </v-flex>

              <v-flex xs6>
                <v-btn flat icon color="pink" @click="deleteacyear(props.item,props.index)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </td>
        </template>
      </v-data-table>

      <m-dialog title="Academic Year" :show="showD" pers>
        <template v-slot:header-actions>
          <v-btn @click="showD=!showD" icon style="cursor:pointer">
            <v-icon>close</v-icon>
          </v-btn>
        </template>

        <template v-slot:content>
          <v-form ref="form">
            <v-text-field label="Title" v-model="acyear_model.name" :rules="validRules.required"/>
            <v-text-field label="Year" v-model="acyear_model.year" type="number" :rules="validRules.required"/>
          </v-form>
        </template>

        <template v-slot:footer-actions>

          <v-btn
            style="cursor:pointer"
            color="success"
            @click="saveacyear()"
            :loading="loading"
          >save</v-btn>
          <v-btn @click="showD=!showD" style="cursor:pointer" color="error">close</v-btn>
        </template>
      </m-dialog>
    </template>
  </sayquick-card>
</template>

<script>
import { mapGetters } from "vuex";
import QuickCard from "../Quickcard";
import Mdialog from "../Modal"
export default {
  name: "academic-year",
  components: {
    "sayquick-card": QuickCard,
     "m-dialog":Mdialog,
  },
  data() {
    return {
      showD:false,
      pers:false,
      search:'',
      sinf_model:{
         active_acyear:'',
      },
       sinf_modelcp:{
        active_acyear:'',
      },
      acyear_model:{},
       acyear_modelcp:{},
      editedIndex:-1,
      years_headers: [
        {
          text: "SN",
          align: "center",
          sortable: true,
          value: "sn"
        },
        {
          text: "Academic Year Title",
          align: "center",
          sortable: false,
          value: "name"
        },
         {
          text: "Year",
          align: "center",
          sortable: false,
          value: "year"
        },
        {
          text: "Status",
          align: "center",
          sortable: false,
          value: "status"
        },
        ,
         {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "actions"
        }
      ],

    };
  },
 mounted() {
    this.$store.dispatch("academicYear/getAll");
     this.$store.dispatch("settings/getAll")


  },
   computed: {
    ...mapGetters({
      acyears: "academicYear/ACYEARS",
      ayerrors: "academicYear/ACYEAR_ERROR",
      loading: "academicYear/ACYEAR_LOADING",

      settings: "settings/SETTINGS",
      serrors: "settings/SETTING_ERROR",
      sloading: "settings/SETTING_LOADING"
    }),


  },

   methods: {
    setSwitchState(val){
      return val.id == this.settings.ayt.acyear.id ? true:false
    },
    savesetting(acyear) {
      this.sinf_model.active_acyear = acyear
      this.$store.dispatch("settings/add", this.sinf_model);

      if (this.serrors==null) {

        this.$store.dispatch('responseMessage', {
                type: 'success',
                text: "Settings saved successfully.",
                title: "Save Settings",
                modal: false
            })
      }else{
        this.sinf_model = this.sinf_modelcp;
        this.$store.dispatch('responseMessage', {
                type: 'warning',
                text: "Sorry settings could not be saved.",
                title: "Save Settings",
                modal: false
            })
      }
    },
      addacyear() {
      this.$store.dispatch("academicYear/add", this.acyear_model);

      if (this.ayerrors==null) {
        this.acyear_model = {};
          this.$store.dispatch('responseMessage', {
                type: 'success',
                text: "Academic year saved successfully",
                title: "Academic Year",
                modal: false
            })
      }else{
          this.$store.dispatch('responseMessage', {
                type: 'warning',
                text: "Sorry Academic Year could not be saved.",
                title: "Academic Year",
                modal: false
            })
      }
    },
    deleteacyear(acyear, index) {
      if (confirm("Are you sure you want to delete this academic year?")) {
        this.$store.dispatch("academicYear/delete", { acyear, index });

          this.$store.dispatch('responseMessage', {
                type: 'success',
                text: "Academic year deleted successfully",
                title: "Academic Year",
                modal: false
            })
      }
    },

    editacyear(acyear) {
      this.editedIndex = this.acyears.indexOf(acyear);
      this.acyear_model = Object.assign({}, acyear);

      //alert(this.editedIndex)

      this.showD = true;
    },
    updateacyear(acyear, index) {
      this.$store.dispatch("academicYear/update", { index, acyear });

      if (this.ayerrors==null) {
        this.acyear_model = {};
        this.editedIndex = -1;
        this.showD = false;

          this.$store.dispatch('responseMessage', {
                type: 'success',
                text: "Academic year updated successfully",
                title: "Academic Year",
                modal: false
            })
      }
    },
    saveacyear() {
      if (!this.$refs.form.validate()) {
        return;
      }
      //decides between editing acyear info or saving acyear info
      if (this.editedIndex > -1) {
        this.updateacyear(this.acyear_model, this.editedIndex);
      } else {
        this.addacyear();
      }
    }
  },
    watch:{
    showD(val){
      if(val==false){
        this.acyear_model = this.acyear_modelcp;
      }
    },

  },

};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/settings/schoolAcademicYears.vue